import { render, staticRenderFns } from "./DealsFilters.vue?vue&type=template&id=b1347f06&"
import script from "./DealsFilters.vue?vue&type=script&lang=js&"
export * from "./DealsFilters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports